import { FiUser, FiMail, FiPhone, FiEdit } from 'react-icons/fi';

export default function ViewUser({ currentUser, setEditUser }) {
  const { fullName, email, contact } = currentUser;
  return (
    <div className="max-w-md mx-auto bg-white shadow rounded-lg p-6 space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold">User</h2>
        <button
          onClick={() => setEditUser(true)}
          className="text-primary-500 hover:text-primary-700 flex items-center gap-1"
        >
          <FiEdit /> Edit
        </button>
      </div>
      <div className="space-y-3">
        <div className="flex items-center gap-3">
          <FiUser className="text-gray-600 text-lg" />
          <span className="font-medium">Name:</span>
          <span>{fullName}</span>
        </div>
        <div className="flex items-center gap-3">
          <FiMail className="text-gray-600 text-lg" />
          <span className="font-medium">Email:</span>
          <span>{email}</span>
        </div>
        <div className="flex items-center gap-3">
          <FiPhone className="text-gray-600 text-lg" />
          <span className="font-medium">Contact:</span>
          <span>{contact}</span>
        </div>
      </div>
    </div>
  );
}
